/*
 * APX Upsell 1-clic
 * Ajoute au panier le produit upsell (case a cocher) en meme temps que le produit principal.
 * Fonctionne avec le systeme pub/sub natif du theme Dawn (assets/pubsub.js + assets/constants.js).
 * Ce fichier peut etre inclus plusieurs fois sur une page (cart-drawer + fiche produit) : il ne
 * s'initialise qu'une seule fois grace au flag window.__apxUpsellInitialized.
 */
(function () {
  if (window.__apxUpsellInitialized) return;
  window.__apxUpsellInitialized = true;

  function addUpsellToCart(variantId, checkbox) {
    if (!variantId) return;

    checkbox.disabled = true;

    var cartElement = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var sections = [];
    if (cartElement && typeof cartElement.getSectionsToRender === 'function') {
      sections = cartElement.getSectionsToRender().map(function (section) {
        return section.id;
      });
    }

    var body = JSON.stringify({
      items: [{ id: variantId, quantity: 1 }],
      sections: sections,
      sections_url: window.location.pathname,
    });

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body,
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        checkbox.disabled = false;

        if (response.status) {
          console.error('APX upsell: echec ajout au panier', response);
          checkbox.checked = false;
          return;
        }

        checkbox.checked = false;
        var wrapper = checkbox.closest('.apx-upsell');
        if (wrapper) wrapper.remove();

        if (cartElement && typeof cartElement.renderContents === 'function') {
          cartElement.renderContents(response);
        }
      })
      .catch(function (error) {
        checkbox.disabled = false;
        console.error('APX upsell error', error);
      });
  }

  // Cas 1 : la case est deja dans le panier (cart-drawer) et l'utilisateur la coche directement.
  document.addEventListener('change', function (event) {
    var checkbox = event.target.closest('[data-apx-upsell-checkbox]');
    if (!checkbox || !checkbox.checked) return;
    if (checkbox.closest('product-form')) return; // cas 2, gere via cartUpdate ci-dessous
    addUpsellToCart(checkbox.dataset.apxUpsellVariantId, checkbox);
  });

  // Cas 2 : la case est sur la fiche produit. On attend la confirmation d'ajout du produit
  // principal (evenement cartUpdate publie par product-form.js) avant d'ajouter l'upsell,
  // afin de ne faire qu'une seule ouverture/rafraichissement du panier.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event.source !== 'product-form') return;

      var checkbox = document.querySelector('product-form [data-apx-upsell-checkbox]:checked');
      if (!checkbox) return;

      addUpsellToCart(checkbox.dataset.apxUpsellVariantId, checkbox);
    });
  }
})();
